module.exports = __webpack_public_path__ + "static/img/A110.785b8a43.jpg";